import React from "react";
import Button from "../../components/Button";

export function PlanCardButton({
    plan,
    tier,
    isCurrentPlan,
    isLoading,
    needsResume,
    isUpgrade,
    isDowngrade,
    isBillingCycleChange,
    hasActiveSubscription,
    isYearly,
    buttonStyle,
    onSelect,
    onResume,
    t,
}) {
    const getButtonClass = () => {
        if (isCurrentPlan && !needsResume) return "bg-slate-100 text-slate-400 cursor-not-allowed";
        if (needsResume) return "bg-emerald-600 hover:bg-emerald-700 text-white";
        if (isBillingCycleChange) return "bg-emerald-600 hover:bg-emerald-700 text-white";
        if (isUpgrade) return "bg-emerald-600 hover:bg-emerald-700 text-white";
        if (isDowngrade) return "bg-orange-500 hover:bg-orange-600 text-white";
        return buttonStyle;
    };

    const getPlanName = () => {
        return plan.nameKey
            ? t(`billing.planNames.${plan.nameKey}`, { defaultValue: plan.name })
            : plan.name;
    };

    const getButtonText = () => {
        if (isLoading) return t("billing.loading") || "Loading...";
        if (needsResume) return t("billing.resumeSubscription") || "Resume Subscription";
        if (isCurrentPlan) return t("billing.currentPlan") || "Current Plan";
        if (isBillingCycleChange) {
            return isYearly
                ? t("billing.switchToYearly") || "Switch to Yearly"
                : t("billing.switchToMonthly") || "Switch to Monthly";
        }
        if (hasActiveSubscription && isUpgrade) {
            return t("billing.upgradeToPlan", { plan: getPlanName(), defaultValue: `Upgrade to ${plan.name}` });
        }
        if (hasActiveSubscription && isDowngrade) {
            return t("billing.downgradeToPlan", { plan: getPlanName(), defaultValue: `Downgrade to ${plan.name}` });
        }
        return tier === "better"
            ? t("billing.startBuilding") || "Start Building"
            : t("billing.getStarted") || "Get Started";
    };

    return (
        <Button
            onClick={() => (needsResume ? onResume() : onSelect(plan))}
            disabled={isLoading || (isCurrentPlan && !needsResume)}
            className={`w-full py-3.5 rounded-xl font-semibold text-base transition-all duration-200 ${getButtonClass()} disabled:opacity-50`}
        >
            {getButtonText()}
        </Button>
    );
}
